// Parses a free-form Dutch/English webinar date string and determines if it's in the future.
// Supports formats like "12 mei 2026", "12 May 2026", "2026-05-12", "12-05-2026".

const NL_MONTHS: Record<string, number> = {
  jan: 0, januari: 0,
  feb: 1, februari: 1,
  mrt: 2, maart: 2, mar: 2,
  apr: 3, april: 3,
  mei: 4, may: 4,
  jun: 5, juni: 5,
  jul: 6, juli: 6,
  aug: 7, augustus: 7,
  sep: 8, sept: 8, september: 8,
  okt: 9, oct: 9, oktober: 9, october: 9,
  nov: 10, november: 10,
  dec: 11, december: 11,
};

export function parseWebinarDate(dateStr: string | null | undefined): Date | null {
  if (!dateStr) return null;
  const s = dateStr.trim().toLowerCase();

  // ISO: 2026-05-12
  const iso = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (iso) {
    return new Date(Number(iso[1]), Number(iso[2]) - 1, Number(iso[3]));
  }

  // dd-mm-yyyy or dd/mm/yyyy
  const dmy = s.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})/);
  if (dmy) {
    return new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
  }

  // "12 mei 2026" / "12 May 2026"
  const named = s.match(/(\d{1,2})\s+([a-z]+)\.?\s+(\d{4})/);
  if (named) {
    const month = NL_MONTHS[named[2]];
    if (month !== undefined) {
      return new Date(Number(named[3]), month, Number(named[1]));
    }
  }

  const fallback = new Date(dateStr);
  return isNaN(fallback.getTime()) ? null : fallback;
}

export function isUpcomingWebinar(dateStr: string | null | undefined): boolean {
  const d = parseWebinarDate(dateStr);
  if (!d) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return d.getTime() > today.getTime();
}
